export default "__VITE_ASSET__BNij3z$r__"